<fdb-project-setup-risk [projectId]="projectId"></fdb-project-setup-risk>
<fdb-project-setup-milestone [projectId]="projectId"></fdb-project-setup-milestone>
<fdb-project-setup-team [projectId]="projectId"></fdb-project-setup-team>
